import React from 'react';

import ErrorPage from '../../base/partials/error-page';

interface props {
    children?: React.ReactNode;
}

interface state {
    error?: Error;
    info?: React.ErrorInfo;
}

export default class ErrorHandler extends React.Component<props, state> {
    state: state = {};

    static getDerivedStateFromError = (error: Error): state => ({error});

    componentDidCatch = (error: Error, info: React.ErrorInfo): void => {
        this.setState({info});
    };

    render = (): React.ReactNode => {
        return this.state.error ? (
            <ErrorPage error={this.state.error} info={this.state.info} />
        ) : (
            <>{this.props.children}</>
        );
    };
}
